"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconButton = _interopRequireDefault(require("material-ui/IconButton"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _arrowDownward = _interopRequireDefault(require("material-ui/svg-icons/navigation/arrow-downward"));
var _arrowUpward = _interopRequireDefault(require("material-ui/svg-icons/navigation/arrow-upward"));
var _done = _interopRequireDefault(require("material-ui/svg-icons/action/done"));
var _MenuItem = _interopRequireDefault(require("material-ui/MenuItem"));
var _PopupMenu = _interopRequireDefault(require("../PopupMenu"));
require("./CardBrowserFilter.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var CardBrowserFilter = /*#__PURE__*/function (_Component) {
  _inherits(CardBrowserFilter, _Component);
  var _super = _createSuper(CardBrowserFilter);
  function CardBrowserFilter(props) {
    var _this;
    _classCallCheck(this, CardBrowserFilter);
    _this = _super.call(this, props);
    _this.state = {
      sortByTypeKey: _this.props.sortByType,
      sortByType: _this.getLabelForOption(_this.props.sortByType),
      sortByOrder: _this.props.sortByOrder,
      labelBack: "transparent",
      iconBack: "transparent"
    };
    _this.handleSortByTypeChange = _this.handleSortByTypeChange.bind(_assertThisInitialized(_this));
    _this.handleIconHover = _this.handleIconHover.bind(_assertThisInitialized(_this));
    _this.handleIconOut = _this.handleIconOut.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(CardBrowserFilter, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.state.sortByType !== nextProps.sortByType || this.state.sortByOrder !== nextProps.sortByOrder) {
        this.setState({
          sortByType: this.getLabelForOption(nextProps.sortByType),
          sortByOrder: nextProps.sortByOrder,
          sortByTypeKey: nextProps.sortByType
        });
      }
    }
  }, {
    key: "handleSortByTypeChange",
    value: function handleSortByTypeChange(value) {
      var currentSortByOrder = this.state.sortByOrder;
      this.setState({
        sortByType: this.getLabelForOption(value),
        sortByOrder: currentSortByOrder,
        sortByTypeKey: this.props.sortByType
      });
      this.props.onSortByClick(value);
    }
  }, {
    key: "handleIconHover",
    value: function handleIconHover() {
      var currentState = this.state;
      currentState.iconBack = this.props.labelBackHover;
      this.setState(currentState);
    }
  }, {
    key: "handleIconOut",
    value: function handleIconOut() {
      var currentState = this.state;
      currentState.iconBack = "transparent";
      this.setState(currentState);
    }
  }, {
    key: "getLabelForOption",
    value: function getLabelForOption(value) {
      var label = value;
      this.props.sortByTypeOptions && (0, _map2["default"])(this.props.sortByTypeOptions, function (option) {
        if (option.value === value) label = option.label;
      });
      return label;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var iconButtonStyle = {
        borderRadius: 30,
        height: 36,
        width: 36,
        padding: 6,
        marginTop: 6,
        background: this.state.iconBack
      };
      var iconStyle = {
        color: this.props.iconColor,
        width: 36,
        height: 36
      };
      var viewBox = "0 0 36 36";
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "card-browser-filter"
      }, /*#__PURE__*/_react["default"].createElement(_PopupMenu["default"], {
        value: this.state.sortByType,
        action: this.handleSortByTypeChange
      }, this.props.sortByTypeOptions && (0, _map2["default"])(this.props.sortByTypeOptions, function (option) {
        return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
          style: {
            fontSize: 14
          },
          value: option.value,
          leftIcon: option.value === _this2.state.sortByTypeKey ? /*#__PURE__*/_react["default"].createElement(_done["default"], null) : /*#__PURE__*/_react["default"].createElement(_done["default"], {
            color: "rgba(255,255,255,0)"
          }),
          primaryText: option.label,
          key: option.value
        });
      })), /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
        onClick: function onClick() {
          return _this2.props.onSortByOrderClick(_this2.state.sortByOrder === "desc" ? "asc" : "desc");
        },
        onMouseEnter: this.handleIconHover,
        onMouseLeave: this.handleIconOut,
        tooltip: "Reverse sort direction",
        tooltipPosition: "bottom-center",
        iconStyle: iconStyle,
        style: iconButtonStyle
      }, this.state.sortByOrder === "asc" ? /*#__PURE__*/_react["default"].createElement(_arrowUpward["default"], {
        viewBox: viewBox
      }) : /*#__PURE__*/_react["default"].createElement(_arrowDownward["default"], {
        viewBox: viewBox
      })));
    }
  }]);
  return CardBrowserFilter;
}(_react.Component);
CardBrowserFilter.defaultProps = {
  labelBackHover: "rgba(255, 255, 255, 0.10)",
  iconColor: "rgba(255, 255, 255, 0.7)"
};
CardBrowserFilter.propTypes = {
  onSortByClick: _propTypes["default"].func,
  onSortByOrderClick: _propTypes["default"].func,
  sortByTypeOptions: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].object]),
  sortByType: _propTypes["default"].string,
  sortByOrder: _propTypes["default"].string,
  // Styles
  labelBackHover: _propTypes["default"].string,
  iconColor: _propTypes["default"].string
};
var _default = CardBrowserFilter;
exports["default"] = _default;